import { createContext, useContext } from 'react';

import type { SearchType } from 'modules/search/types/SearchType';

export type DesktopSearchBarContextValue = {
  defaultSearchType: SearchType;
  searchTypeForPopularSearches: SearchType;
  submit: (options: { triggeredByRemoteLocationChange: boolean }) => void;
  setSearchTypeForPopularSearches: (searchType: SearchType) => void;
};

export const DesktopSearchBarContext =
  createContext<DesktopSearchBarContextValue>({
    defaultSearchType: 'JOB',
    searchTypeForPopularSearches: 'JOB',
    setSearchTypeForPopularSearches: () => {
      throw new Error('Missing context');
    },
    submit: () => {
      throw new Error('Missing context');
    },
  });

export function usePageHeaderSearchInputsDesktopContext() {
  return useContext(DesktopSearchBarContext);
}
